function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useEventTracker } from '@applyboard/ui-utils';
import useCefNavigation from "../CEF/Hooks/useCefNavigation";
import { pages, studentOnboarding } from "./consts";
import { OnboardingFlowPages, Routes } from "../CEF/Common/Constants";
import * as backgroundImgs from "../../assets/images/backgrounds";
import { useAppContext } from "../CEF/Providers";
import { shuffleArray } from "../CEF/Utilities/Helper";
var OnboardingFormControllerContext = /*#__PURE__*/React.createContext(undefined);
var eventPrefix = "".concat(studentOnboarding, " - Pref");
var countryCodeToBackgroundMap = {
  AU: backgroundImgs.Australia,
  CA: backgroundImgs.Canada,
  IE: backgroundImgs.Ireland,
  GB: backgroundImgs.GB,
  US: backgroundImgs.USA,
  DE: backgroundImgs.Germany
};
export var createPageToBackgroundMap = function createPageToBackgroundMap(countries) {
  if (countries.length === 0) {
    return {};
  }
  var pagesWithCountryBackgrounds = OnboardingFlowPages.filter(function (page) {
    return ![Routes.Preferences.FirstNamePage, Routes.Preferences.WelcomePage, Routes.Preferences.CountriesPage].includes(page);
  });
  var NUM_BACKGROUNDS_PER_COUNTRY_PER_CYCLE = 3;
  var pageToBackgroundMapEntries = pagesWithCountryBackgrounds.map(function (page, pageIndex) {
    var numCountries = countries.length;
    var numBackgroundsPerCycle = NUM_BACKGROUNDS_PER_COUNTRY_PER_CYCLE * numCountries;
    var countryIndexInCurrentCycle = pageIndex % numBackgroundsPerCycle;
    var backgroundIndex = Math.floor(countryIndexInCurrentCycle / NUM_BACKGROUNDS_PER_COUNTRY_PER_CYCLE);
    var background = countryCodeToBackgroundMap[countries[backgroundIndex]];
    return [page, background];
  });
  return Object.fromEntries(pageToBackgroundMapEntries);
};
export var OnboardingFormController = function OnboardingFormController(_ref) {
  var children = _ref.children,
    onExit = _ref.onExit;
  var history = useHistory();
  var location = useLocation();
  var _useAppContext = useAppContext(),
    onboardingMode = _useAppContext.onboardingMode;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var navigateCef = useCefNavigation();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    pageToBackgroundMap = _useState2[0],
    setPageToBackgroundMap = _useState2[1];
  var currentPage = location.pathname;
  var background = onboardingMode && Object.keys(pageToBackgroundMap).length > 0 && OnboardingFlowPages.indexOf(currentPage) > OnboardingFlowPages.indexOf(Routes.Preferences.CountriesPage) ? pageToBackgroundMap[currentPage] : backgroundImgs.Generic;
  var proceed = function proceed() {
    var nextPage = pages[history.location.pathname].nextPage;
    if (nextPage) {
      navigateCef(nextPage);
    }
  };
  var buildEventName = function buildEventName(event) {
    var pathname = history.location.pathname;
    if (pathname === Routes.ApplyBoost.PathwayPage) {
      return "".concat(studentOnboarding, " - Applyboost Modal - ").concat(event, " ").concat(pages[pathname].title);
    }
    // questionNumber is either 'Q1' ... 'Q7', OR it is '' for the intro page
    var questionNumber = pages[pathname].questionNumber;
    var questionLabel = questionNumber === '' ? '' : " ".concat(questionNumber);
    return "".concat(eventPrefix).concat(questionLabel, ": ").concat(event, " ").concat(pages[pathname].title);
  };
  var handlePassed = function handlePassed(eventData) {
    trackEvent({
      event: buildEventName('Passed'),
      group: studentOnboarding,
      data: eventData
    });
    proceed();
  };
  var handleSkipped = function handleSkipped() {
    trackEvent({
      event: buildEventName('Skipped'),
      group: studentOnboarding
    });
    proceed();
  };
  var handleExit = function handleExit() {
    trackEvent({
      event: buildEventName('Dismissed'),
      group: studentOnboarding
    });
    onExit();
  };
  var handleError = function handleError() {
    trackEvent({
      event: buildEventName('Encountered Error'),
      group: studentOnboarding
    });
  };
  var setCountries = function setCountries(countries) {
    shuffleArray(countries);
    setPageToBackgroundMap(createPageToBackgroundMap(countries));
  };
  var value = {
    handlePassed: handlePassed,
    handleSkipped: handleSkipped,
    handleExit: handleExit,
    handleError: handleError,
    background: background,
    setCountries: setCountries
  };
  return /*#__PURE__*/React.createElement(OnboardingFormControllerContext.Provider, {
    value: value
  }, children);
};
export var useOnboardingFormControllerContext = function useOnboardingFormControllerContext() {
  var context = React.useContext(OnboardingFormControllerContext);
  if (context === undefined) {
    throw new Error('useOnboardingFormControllerContext must be used within a OnboardingFormController');
  }
  return context;
};